import type { AlertListQuery } from '@chukua/common';
import { Tag } from 'antd';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import { isUnacknowledgedOnly } from '../policies/alert-quick-filters';

interface AlertQuickFiltersProps {
  list: ListQueryControls<AlertListQuery>;
}

/**
 * The three questions an operator opens the inbox with. Each is a plain URL param (`mine`, `status=open`, `overdue`), so a link to a
 * filtered inbox works and the column filters show the same state. They combine: mine and overdue is "mine, and late".
 */
export function AlertQuickFilters({ list }: AlertQuickFiltersProps) {
  const { query, setQuery } = list;
  // A bordered chip, so an unchecked one still reads as something to press.
  const chip = 'm-0 border border-solid border-primary/40 px-3 py-1';
  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Quick filters">
      <Tag.CheckableTag className={chip} checked={query.mine === true} onChange={(on) => setQuery({ mine: on ? true : undefined })}>
        Mine
      </Tag.CheckableTag>
      <Tag.CheckableTag className={chip} checked={isUnacknowledgedOnly(query)} onChange={(on) => setQuery({ status: on ? ['open'] : undefined })}>
        Unacknowledged
      </Tag.CheckableTag>
      <Tag.CheckableTag className={chip} checked={query.overdue === true} onChange={(on) => setQuery({ overdue: on ? true : undefined })}>
        Overdue
      </Tag.CheckableTag>
    </div>
  );
}
